/* eslint-disable indent */
import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';

import './index.scss';
import classNames from 'classnames';

const CustomTags = ({
  custom_tags = [],
  conversation_tags,
  modelopen,
  setblockOverlayVisibility,
  addCustomTags,
  addingTagToUser,
  conversation,
}) => {

  const tagRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);

  // Get all existing user tags
  const existing = conversation?.details?.user_tags?.map(tag => tag.id) || [];

  // Memoize location-specific existing tags
  const existingLocationSpecificTag = useMemo(() => {
    const locationSpecificTags = custom_tags.map(tag => tag.id);
    return conversation?.details?.user_tags?.filter(
      tag => locationSpecificTags.includes(tag.id)
    ) || [];
  }, [conversation?.details?.user_tags, custom_tags]);

  // Get IDs of existing location-specific tags
  const existingLocationSpecificIds = useMemo(() =>
    existingLocationSpecificTag.map(tag => tag.id),
    [existingLocationSpecificTag]
  );

  // Initialize/update selectedTags whenever existingLocationSpecificTag changes
  useEffect(() => {
    setSelectedTags(existingLocationSpecificTag);
  }, [JSON.stringify(existingLocationSpecificIds)]); // Use JSON.stringify to compare array contents

  const closeModal = useCallback(() => {
    setblockOverlayVisibility(false);
  }, [setblockOverlayVisibility]);

  const hideDropdown = useCallback(
    (event) => {
      if (
        tagRef &&
        tagRef.current &&
        tagRef.current.contains(event.target)
      ) {
        return;
      }

      if (!modelopen || !setblockOverlayVisibility) return;

      if (
        !(event.target.type === 'checkbox' ||
          event.target.tagName === 'LABEL')
      ) {
        setblockOverlayVisibility(false);
      }
    },
    [tagRef, modelopen, setblockOverlayVisibility]
  );

  useEffect(() => {
    window.addEventListener('click', hideDropdown);

    return () => {
      window.removeEventListener('click', hideDropdown);
    };
  }, [hideDropdown]);

  /** Handle click on each checkbox **/
  const handleCheck = (tag) => {
    const isAlreadySelected = selectedTags.find((t) => t.id === tag.id);
    if (isAlreadySelected) {
      setSelectedTags((prev) => prev.filter((t) => t.id !== tag.id));
    } else {
      const newTagsCount = selectedTags.filter(t => t.id).length;
      if (newTagsCount < (2 - (existing.length - existingLocationSpecificTag.length))) {
        setSelectedTags((prev) => [...prev, tag]);
      }
    }
  };

  /** ADD button clicked **/
  const addTags = () => {
    console.log('Selected Tags:', selectedTags);
    // Only send NEW tags that aren't already in existingLocationSpecificTag
    const newTagsToAdd = selectedTags.filter(tag => tag.id);
    addCustomTags(newTagsToAdd);
  };

  /** Clear selected tags - keep existing location-specific tags **/
  const clearTags = () => {
    setSelectedTags(existingLocationSpecificTag);
  };

  const firstColumn = custom_tags.slice(0, 5);
  const secondColumn = custom_tags.slice(5);
  const limit_not_reached = (selectedTags?.filter(t => t.id).length < (2 - (existing?.length - existingLocationSpecificTag?.length)));
  console.log('limit_reached', limit_not_reached);
  return (
    <div className="add-tags-modal" ref={tagRef}>
      <div className="title">
        <div className="sub-title">{'CUSTOM TAGS (max 2 tags)'}</div>
        <button className="modal-close" onClick={closeModal}>
          <i className="material-icons">close</i>
        </button>
      </div>
      <div className="tags-wrapper">
        {/* Column 1: first 5 */}
        <div className="tags-column">
          {firstColumn.map((tag) => {
            const isExisting = existingLocationSpecificIds.includes(tag.id);
            return (
              <div
                className={`custom-tag ${isExisting ? 'existing-tag' : ''}`}
                key={tag.id}
                onClick={() => handleCheck(tag)}
              >
                <div className="custom-tag_element">
                  <div className="custom-tag_element_data">
                    <input
                      type="checkbox"
                      value={tag.id}
                      name={tag.id}
                      checked={!!(selectedTags.find((t) => t.id === tag.id))}
                      readOnly
                      disabled={!limit_not_reached && !selectedTags.find((t) => t.id === tag.id)}
                    />
                    <label className={classNames('filter-name', { 'disabled': (!limit_not_reached && !selectedTags.find((t) => t.id === tag.id)) })} htmlFor={tag.id}>
                      {tag.name}
                    </label>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Column 2: spillover */}
        {secondColumn.length > 0 && (
          <div className="tags-column">
            {secondColumn.map((tag) => {
              const isExisting = existingLocationSpecificIds.includes(tag.id);
              return (
                <div
                  className={`custom-tag ${isExisting ? 'existing-tag' : ''}`}
                  key={tag.id}
                  onClick={() => handleCheck(tag)}
                >
                  <div className="custom-tag_element">
                    <div className="custom-tag_element_data">
                      <input
                        type="checkbox"
                        value={tag.id}
                        name={tag.id}
                        checked={!!(selectedTags.find((t) => t.id === tag.id))}
                        readOnly
                      />
                      <label className="filter-name" htmlFor={tag.id}>
                        {tag.name}
                      </label>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="actions">
        <button
          className="btn btn--primary btn--lg"
          disabled={addingTagToUser || selectedTags.length === 0}
          onClick={addTags}
        >
          {addingTagToUser ? 'ADDING...' : 'ADD'}
        </button>
        <button className="btn btn--secondary btn--lg" onClick={clearTags}>
          clear
        </button>
      </div>
    </div>
  );
};

export default CustomTags;
